export const SCROLL_ICON_OVERLAY_PX = 64;

// Arrows must appear for ANY real overflow — even a few px (e.g. a 3-pill AI row clipping only its trailing
// 16px gap) — so the tolerance only absorbs sub-pixel scroll rounding, not genuinely hidden content.
export const SCROLL_EDGE_TOLERANCE_PX = 2;
